import L from 'leaflet';
import "leaflet.vectorgrid";


var core = require("@react-leaflet/core");


// Problem:
// For this styling, the attribute must be known in advance.

function createMVT(props: any, context: any) {
    const instance = L.vectorGrid.protobuf(props.url, props.options);
    return {
        instance: instance,
        context: { ...context, overlayContainer: instance },
    };
}

function updateMVT(instance: any, props: any, prevProps: any) {


}

const ProtobufLayerComponent = core.createPathComponent(createMVT, updateMVT);

export function ProtobufLayer(props: any) {

    // We need an attribute to style the layer https://stackoverflow.com/questions/61233583/styling-vectorgrid-layer-in-leaflet 
    //or use import "vectorTileLayer from 'leaflet-vector-tile-layer';". Then the core.createPathComponent library can't be used.

    const protobufStyles = {
        fill: false,
        // Stroke properties
        stroke: true,
        color: "green",
        weight: 0.8,
    };

    // const protobufStyles = {
    //     Bundeslaender_Waldzustand: function (properties: any, zoom: any) {
    //         console.log(properties)
    //         // Ref: https://leafletjs.com/reference-1.7.1.html#path

    //         if (properties.RS == props.selectedAreaId) {
    //             return {
    //                 // Stroke properties
    //                 stroke: true,
    //                 color: "white",
    //                 weight: 1.7,

    //                 // opacity: 1
    //             }
    //         } else {
    //             return {
    //                 stroke: false

    //             }
    //         }
    //     },
    // }

    return (
        <ProtobufLayerComponent
            url={props.url}
            options={{
                rendererFactory: L.canvas.tile,
                vectorTileLayerStyles: protobufStyles,
                // interactive: true,
                zIndex: 100,
                // minZoom: config.mapSettings.minZoom,
                // maxZoom: config.mapSettings.maxZoom,
                // maxNativeZoom: config.mapSettings.nativeZoom
            }}

        >

        </ProtobufLayerComponent>

    );


}